
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import ProjectForm from "@/components/projects/ProjectForm";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

const EditProject = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [projectData, setProjectData] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        if (!id) return;
        
        setIsLoading(true);
        const { data, error } = await supabase
          .from("projects")
          .select("*")
          .eq("id", id)
          .single();

        if (error) {
          throw error;
        }

        console.log("Fetched project data:", data);
        setProjectData(data);
      } catch (error) {
        console.error("Error fetching project:", error);
        toast({
          title: "Error",
          description: "Failed to load project data",
          variant: "destructive",
        });
        navigate("/projects");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProject();
  }, [id, navigate, toast]);

  if (isLoading) {
    return (
      <Layout>
        <div className="section-container flex justify-center items-center min-h-[60vh]">
          <div className="animate-pulse">Loading project data...</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="section-container">
        <h1 className="section-title mb-8">
          <span className="gradient-text">Edit Project</span>
        </h1>
        <p className="text-center text-muted-foreground mb-8">
          Update your project details and images below.
        </p>
        {projectData && <ProjectForm project={projectData} isEditing={true} />}
      </div>
    </Layout>
  );
};

export default EditProject;
